
import api from './api';

const endpoint = '/api/cadastros-internos';

const CadastrosInternosService = {
  getAll: async () => {
    const response = await api.get(endpoint);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`${endpoint}/id/${id}`);
    return response.data;
  },

  getPermissao: async () => {
    const response = await api.get(`${endpoint}/permissao`);  
    return response.data;
  },

  create: async (data) => {
    const response = await api.post(endpoint, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`${endpoint}/${id}`, data);
    return response.data;
  },

  updatePermissao: async (id, data) => {
    const response = await api.patch(`${endpoint}/permissao-acesso/${id}`, data);
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`${endpoint}/${id}`);
    return response.data;
  },
};

export default CadastrosInternosService;